// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"a019d535","171":"a591ed1e","432":"780e6644","886":"94af7f19","979":"f4094f03","994":"792122b0"}[chunkId] + ".chunk.js";
};